import App from "./App";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/system";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);
